module.exports = __webpack_public_path__ + "static/media/our_service_inner_tab_newbg1.f01f5083.png";